import React from "react";
import { useAccessToken } from "@/Auth/useAccessToken";
import { useQueryClient } from "@tanstack/react-query";
import { forgetHomePath } from "@/pages/SEmbed/fullAppPaths";

export function useLogout() {
  const queryClient = useQueryClient();
  const { removeAccessToken } = useAccessToken();

  const logout = React.useCallback(() => {
    removeAccessToken();
    // The theme is a device preference and stays; where this user was in S does not.
    forgetHomePath();
    queryClient.cancelQueries().then(() => {
      queryClient.clear();
    });
  }, [queryClient, removeAccessToken]);

  return { logout };
}
